<mat-progress-bar
*ngIf="loading" mode="indeterminate">
</mat-progress-bar>
<router-outlet></router-outlet>
<ngx-spinner></ngx-spinner>
